'use client'
import {
  BenefitsList_default
} from "./chunk-UYKLOVAV.mjs";
import {
  __spreadProps,
  __spreadValues
} from "./chunk-BTG5EALA.mjs";

// src/components/plans/ExpandableBenfitsList.tsx
import { useState } from "react";
import { Button } from "@wbk/ui";
import { ChevronIcon } from "@wbk/svg";
import { twMerge } from "tailwind-merge";
import { useTranslation } from "@wbk/config";
import { jsx, jsxs } from "react/jsx-runtime";
var ExpandablePlanBenefits = ({
  benefits,
  riyadhSeason,
  limit = 3,
  groupClassName = "",
  className = ""
}) => {
  const { t } = useTranslation("subscription_common");
  const [expanded, setExpanded] = useState(false);
  const visibleBenefits = expanded ? benefits : benefits.slice(0, limit);
  return /* @__PURE__ */ jsxs("div", { className: groupClassName, children: [
    /* @__PURE__ */ jsx(
      BenefitsList_default,
      {
        benefits: visibleBenefits.map((b) => {
          return __spreadProps(__spreadValues({}, b), { description: void 0 });
        }),
        riyadhSeason,
        className: twMerge("space-y-2 text-sm [&_img]:h-4 [&_img]:w-4 [&_li]:gap-2", className)
      }
    ),
    benefits.length > 3 && /* @__PURE__ */ jsxs(
      Button,
      {
        onClick: () => setExpanded(!expanded),
        shape: "text",
        theme: "action",
        className: "mt-2 px-0.5 py-0 text-sm underline !ring-0 hover:underline focus:underline",
        children: [
          /* @__PURE__ */ jsx("span", { children: expanded ? t("subscription_common:see_less_benefits") : t("subscription_common:see_all_benefits") }),
          /* @__PURE__ */ jsx(ChevronIcon, { className: `h-3 w-3 ${expanded ? "-rotate-90" : "rotate-90"}` })
        ]
      }
    )
  ] });
};
var ExpandableBenfitsList_default = ExpandablePlanBenefits;

export {
  ExpandableBenfitsList_default
};
//# sourceMappingURL=chunk-6RPHG7BM.mjs.map